var styles = {"labelWrapper":"rereq-container--label-wrapper","label":"rereq-container--label","tooltip":"rereq-container--tooltip","rereqTestsWrapper":"rereq-container--rereq-tests-wrapper","rereqTest":"rereq-container--rereq-test"};

export { styles as default };
//# sourceMappingURL=RereqContainer.module.esm.js.map
